import { LayoutSetup, StepItemsList } from "@/components/setup/layout-setup";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { redirectTo } from "@/lib/location";
import { useEffect, useMemo } from "react";
import "react-chrome-dino-ts/index.css";
import { SetupTeamCreationWelcomePage } from "./team-creation/0-welcome";
import { SetupTeamCreationSurveyPage } from "./team-creation/1-survey";
import { SetupTeamCreationInfosPage } from "./team-creation/2-informations";
import { SetupTeamCreationCreatePage } from "./team-creation/3-create-team";
import { SetupTeamCreationAIResumePage } from "./team-creation/4-ai-resume";
import { SetupTeamCreationPaymentMethodPage } from "./team-creation/5-payment-method";
import { SetupTeamCreationFinishPage } from "./team-creation/6-finish";

export const SetupTeamCreationPage = () => {
  const { teamSelected, isManager, isAdmin } = useTeams();
  const { t } = useTranslation();

  const shouldRedirect =
    !!teamSelected?.id &&
    (!teamSelected?.setupTeamCreation || (!isManager && !isAdmin));

  useEffect(() => {
    if (shouldRedirect) {
      redirectTo("/");
    }
  }, [shouldRedirect]);

  const isBillingEnabled = teamSelected?.billingEnabled !== false;

  const steps: StepItemsList = useMemo(() => {
    const baseSteps: StepItemsList = [
      {
        id: "welcome",
        label: t("setup.teamCreation.steps.welcome"),
        element: <SetupTeamCreationWelcomePage />,
      },
      {
        id: "survey",
        label: t("setup.teamCreation.steps.survey"),
        element: <SetupTeamCreationSurveyPage />,
      },
      {
        id: "infos",
        label: t("setup.teamCreation.steps.infos"),
        element: <SetupTeamCreationInfosPage />,
      },
      {
        id: "loading",
        label: t("setup.teamCreation.steps.loading"),
        element: <SetupTeamCreationCreatePage />,
      },
      {
        id: "ai-resume",
        label: t("setup.teamCreation.steps.aiResume"),
        element: <SetupTeamCreationAIResumePage />,
      },
    ];

    if (isBillingEnabled) {
      baseSteps.push({
        id: "payment-method",
        label: t("setup.teamCreation.steps.paymentMethod"),
        element: <SetupTeamCreationPaymentMethodPage />,
      });
    }

    baseSteps.push({
      id: "finish",
      label: t("setup.teamCreation.steps.finish"),
      element: <SetupTeamCreationFinishPage />,
    });

    return baseSteps;
  }, [t, isBillingEnabled]);

  if (shouldRedirect) {
    return null;
  }

  return <LayoutSetup steps={steps} />;
};
